import { ThemeProvider, theme } from "@primer/react";

import deepmerge from "deepmerge";
import { useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.scss";
import { appConst } from "./AppConst";
import BaseStyles from "./BaseStyles";
import { LazyPage } from "./components-ui/loadable";
import { CommonProvider } from "./contexts/common";
import { HubProvider } from "./contexts/HubProvider";
import { useAppDispatch } from "./hooks/useAppDispatch";
import { useAppSelector } from "./hooks/useAppSelector";
import { rootActions } from "./state/actions/rootActions";
import "./helpers/string.extensions";

const AuthorizedContent = LazyPage(import("./content/AuthorizedContent"));
const UnAuthorizedContent = LazyPage(import("./content/UnAuthorizedContent"));
const UnAuthorizedContentVNPT = LazyPage(
  import("./content/UnAuthorizedContentVNPT"),
);

const customTheme = deepmerge(
  {
    ...theme,
    fontSizes: [
      "11px",
      "13px",
      "16px",
      "20px",
      "24px",
      "32px",
      "40px",
      "48px",
      "56px",
    ],
  },
  {
    colorSchemes: {
      light: {
        colors: {
          accent: {
            fg: "var(--primary)",
            emphasis: "var(--primary)",
          },
          // --bgColor-accent-emphasis
          btn: {
            primary: {
              bg: "var(--primary)",
              focusBg: "var(--primary)",
              hoverBg: "var(--primary)",
              selectedBg: "var(--primary)",
              disabledBg: "rgba(222, 63, 15,0.6)",
            },
          },
        },
      },
    },
  },
);

function App() {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((x) => x.auth);
  const { themeMode } = useAppSelector((x) => x.common.layout);

  useEffect(() => {
    if (appConst.OIDC_UNIT === "vnpt") {
      dispatch(rootActions.auth.GET_USER_INFO_VNPT_START(undefined));
    } else {
      dispatch(rootActions.auth.GET_USER_INFO_START(undefined));
    }

    const faviconPath = appConst.LOGO || "/favicon.ico";
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconPath;
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <style>{`
        :root {
          --bg_header: url(/imageStyle/${appConst.THEME}/banner.png);
          --bg_header_left: url(/imageStyle/${appConst.THEME}/bannerLeft.png); 
          --primary: ${appConst.THEME_COLOR_PRIMARY};
          --text_parent: ${appConst.THEME_COLOR_TEXT_PARENT};
          --bg_hover: ${appConst.THEME_COLOR_HOVER};
          --primary_hover: ${appConst.THEME_COLOR_PRIMARY_HOVER};
          --background_scrollbar_track: #f2f2f2;
          --background_scrollbar_thumb: #999;
          --color_product: ${appConst.THEME_COLOR_PRODUCT};
        }
    `}</style>
      <CommonProvider>
        <ThemeProvider theme={customTheme} colorMode={themeMode}>
          <BaseStyles>
            {user && (
              <>
                <HubProvider>
                  <AuthorizedContent />
                </HubProvider>
              </>
            )}
            {!user &&
              (appConst.OIDC_UNIT === "vnpt" ? (
                <UnAuthorizedContentVNPT />
              ) : (
                <UnAuthorizedContent />
              ))}
          </BaseStyles>
        </ThemeProvider>
      </CommonProvider>
    </Router>
  );
}
export default App;
